module.exports = __webpack_public_path__ + "img/012.76dc8881.png";